import React from 'react';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';

import useStyles from './agents-table.styles';
import CollapsibleTableRow from "./AgentsTableRow";
import LoadingTableRow from "../base-table/LoadingTableRow";
import NoDataTableRow from "../base-table/NoDataTableRow";
import {PagedAgentList} from "../../../types/service-types/AgentTypes";
import {useTranslation} from "react-i18next";
import useAuthority from "app/hooks/useAuthority";
import {ROLES} from "app/constants/roles";

interface IProps {
  data: PagedAgentList | null,
  loading: boolean
}

const AgentsTable = (props: IProps) => {
  const classes = useStyles();
  const {t} = useTranslation();
  const {hasUserAnyAuthority} = useAuthority();
  
  const isAdmin = hasUserAnyAuthority([ROLES.ROLE_ADMIN]);
  const isAgent = hasUserAnyAuthority([ROLES.ROLE_AGENT]) && !isAdmin;

  const {data, loading} = props;
  
  const colSpan = isAgent ? 8 : 7;

  return (
      <TableContainer component={Paper}>
        <Table aria-label="collapsible table">
          <TableHead>
            <TableRow className={classes.root}>
              <TableCell style={{fontWeight: 'bold', textAlign: 'center'}}>{t("app.main.schedules.sharedComponents.collapsibleTableRow.tableCell1", "Full name")}</TableCell>
              {/* {isAgent && (
                <>
                  <TableCell style={{fontWeight: 'bold', textAlign: 'center'}}>{t("app.main.agency.agentsList.subAgentName", "Name")}</TableCell>
                  <TableCell style={{fontWeight: 'bold', textAlign: 'center'}}>{t("app.main.agency.agentsList.subAgentSurname", "Surname")}</TableCell>
                </>
              )} */}
              <TableCell style={{fontWeight: 'bold', textAlign: 'center'}}>{t("app.main.employees.employeeList.table.email", "Email")}</TableCell>
              <TableCell style={{fontWeight: 'bold', textAlign: 'center'}}>{t("app.main.employees.employeeList.table.balance", "Balance")}</TableCell>
              <TableCell style={{fontWeight: 'bold', textAlign: 'center'}}>{t("app.main.employees.employeeList.table.phoneNumber", "Phone number")}</TableCell>
              <TableCell style={{fontWeight: 'bold', textAlign: 'center'}}>{t("app.main.customer.customerList.address", "Address")}</TableCell>
              <TableCell style={{fontWeight: 'bold', textAlign: 'center'}}>{t("app.main.employees.employeeList.table.status", "Status")}</TableCell>
              <TableCell style={{fontWeight: 'bold', textAlign: 'center'}}>{t("app.main.employees.employeeList.table.actions", "Actions")}</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {loading ? <LoadingTableRow colSpan={colSpan}/>
                : !data || data.content.length === 0 ? <NoDataTableRow colSpan={colSpan}/>
                    : data.content.map((row) => (
                        <CollapsibleTableRow key={row.id} row={row} isAgent={isAgent}/>
                    ))}
          </TableBody>
        </Table>
      </TableContainer>
  );
};

export default AgentsTable;